/// <reference path="koyori.ts" />
/// <reference path="animation.ts" />

/**
 * レイアウトコンポーネントです。
 */
class KoyoriLayout extends KoyoriElement {

}
window.customElements.define('koy-layout', KoyoriLayout);

/**
 * レイアウトのヘッダ要素のコンポーネントです。koy-layoutタグの直下に配置する必要があります。
 */
class KoyoriLayoutHeader extends KoyoriElement {

	constructor() {
		super();

		window.addEventListener("resize", () => {
			setTimeout(() => this.windowSizeChanged(), 100);
		});
	}

	connectedCallback(): void {
		super.connectedCallback();

		this.windowSizeChanged()
	}

	windowSizeChanged(): void {
		let layout = <HTMLElement>this.closest('koy-layout');
		layout.style.paddingTop = this.offsetHeight + 'px';
	}
}
window.customElements.define('koy-layout-header', KoyoriLayoutHeader);

/**
 * レイアウトのフッタ要素のコンポーネントです。koy-layoutタグの直下に配置する必要があります。
 */
class KoyoriLayoutFooter extends KoyoriElement {

	constructor() {
		super();

		window.addEventListener("resize", () => {
			setTimeout(() => this.windowSizeChanged(), 100);
		});
	}

	connectedCallback(): void {
		super.connectedCallback();

		this.windowSizeChanged()
	}

	private windowSizeChanged() {
		let layout = <HTMLElement>this.closest('koy-layout');
		layout.style.paddingBottom = this.offsetHeight + 'px';
	}
}
window.customElements.define('koy-layout-footer', KoyoriLayoutFooter);

/**
 * レイアウトの補足要素のコンポーネントです。koy-layoutタグの直下に配置する必要があります。
 * <dl>
 * <dt>属性</dt>
 * <dd>horizontal: 横幅いっぱいに表示する場合に設定します</dd>
 * <dd>direction: 隠す際の方向（top、bottom、left、right）</dd>
 * <dd>open: 隠されたコンポーネントが表示される際に設定されます</dd>
 * </dl>
 */
class KoyoriLayoutAside extends KoyoriElement {

	static get observedAttributes() {
		return ['open'];
	}

	private backdrop: HTMLElement;

	openChanged(value: string): void {
		if (value != null) {
			if (this.backdrop == undefined) {
				this.backdrop = document.createElement('div');
				this.backdrop.classList.add('koy-layout-aside-backdrop');
				this.backdrop.style.display = 'none';
				this.backdrop.addEventListener('click', () => {
					this.removeAttribute('open');
				});
				this.parentElement.insertBefore(this.backdrop, this);
			}
			KoyoriAnimation.fadeIn(this.backdrop);
		} else {
			KoyoriAnimation.fadeOut(this.backdrop);
		}
	}

}
window.customElements.define('koy-layout-aside', KoyoriLayoutAside);
